enum GROW2384_ACTIONS {
  TOGGLE_SWITCH = 'TOGGLE_SWITCH',
}

export default GROW2384_ACTIONS;
